<template>
  <div class="main">
    <ul class="card_view">
      <li v-for="(item, index) in cardList" :key="index">
        <p>{{ item.label }}</p>
        <p>{{ item.value }}</p>
      </li>
    </ul>
    <div class="log_view" v-if="tableType != 0">
      <el-button @click="toSte">返回</el-button>
    </div>
    <!-- 时间查询 -->
    <div class="tiem_view">
      <p>时间：</p>
      <div>
        <el-button
          v-for="(item, index) in textButton"
          :key="index"
          @click="quickTime(item.time, index)"
          :class="{ actived: index == isactive }"
          >{{ item.text }}</el-button
        >
      </div>
      <el-date-picker
        v-model="timeData"
        @change="onChangData()"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :disabled="whetherBtn"
        :picker-options="pickerOptions"
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
      <div class="sonbtn">
        <el-button icon="el-icon-refresh" @click="resetBtn()">重置</el-button>
      </div>
      <div class="chang_view" v-if="tableType == 0">
        <p>模块：</p>
        <el-select
          v-model="moduleValue"
          placeholder="请选择"
          @change="onChangData()"
        >
          <el-option label="全部" value="-1"></el-option>
          <el-option
            v-for="(item, index) in moduleArr"
            :key="index"
            :label="item.point_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- 表格 -->
    <div v-loading="loading">
      <div class="table_view" v-if="tableType == 0">
        <el-table :data="tableData" style="width: 100%" :border="true">
          <el-table-column fixed prop="fPointName" label="一级模块">
            <template slot-scope="scope">
              <div @click="toTwoTable(scope.row)" class="top">
                <span class="bd">{{ scope.row.fPointName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="tPointName" label="二级模块">
            <template slot-scope="scope">
              <div @click="toTwoTable(scope.row)" class="top">
                <span class="bd">{{ scope.row.tPointName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pointCount" label="总点击次数（次）">
            <template slot-scope="scope">
              <div @click="toTwoTable(scope.row)" class="top">
                {{ scope.row.pointCount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="userCount" label="总点击人数（人）">
            <template slot-scope="scope">
              <div @click="toTwoTable(scope.row)" class="top">
                {{ scope.row.userCount }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 第二层 -->
      <Tow
        ref="tow"
        v-else-if="tableType == 1"
        :item="rowObj"
        :timeData="timeData"
        @pointId="getPointId"
      />
      <!-- 第三层 -->
      <Three ref="three" v-else-if="tableType == 2 && pointId !== null" />
    </div>
  </div>
</template>

<script>
import Tow from "./TowTable.vue";
import Three from "./ThreeTable.vue";
import yklFirst from "@/api/visualization";

export default {
  data() {
    return {
      cardList: [
        {
          label: "注册用户数",
          value: "0",
        },
        {
          label: "登录按钮点击人数",
          value: "0",
        },
        {
          label: "首页icon点击次数",
          value: "0",
        },
        {
          label: "医院学习icon点击次数",
          value: "0",
        },
      ],
      textButton: [
        {
          text: "昨天",
          id: 1,
          time: "1",
        },
        {
          text: "今天",
          id: 2,
          time: null,
        },
        {
          text: "近7日",
          id: 3,
          time: "7",
        },
        {
          text: "近30日",
          id: 4,
          time: "30",
        },
        {
          text: "自定义",
          id: 4,
          time: "null",
        },
      ],
      moduleValue: "-1",
      clsVnName: "",
      isactive: 1, // 时间按钮颜色状态
      whetherBtn: true, // 启动是否自选
      timeData: [],
      moduleArr: [],
      tableType: 0, // 0 一层 1 二层 2 三层
      token: {
        userID: "",
        guid: "",
      },
      formLabelAlign: {
        examBeginDate: "",
        examEndDate: "",
      },
      pointId: null, // 二级表格ID
      rowObj: {},
      loading: true,
      tableData: [
        {
          date: "首页",
          name: "医学考试",
          province: "123",
          city: "321",
        },
        {
          date: "首页",
          name: "精选好课",
          province: "12",
          city: "33",
        },
      ],
      module: {},
      pickerOptions: {
        disabledDate(time) {
          // 指定上线之前时间禁用
          return time.getTime() < Date.parse("2023-04-12") - 8.64e7;
        },
      },
    };
  },
  components: {
    Tow,
    Three,
  },
  methods: {
    // chang时间查询
    async onChangData() {
      // this.thePielist();
      this.init();
    },
    // 重置
    async resetBtn() {
      this.$nextTick(() => {
        if (this.tableType == 2) {
          this.$refs.three.showpageindex = 1;
          this.$refs.three.currentPage3 = 0;
        }
        this.isactive = 1; // 按钮颜色
        // let tiem = this.$moment().format("YYYY-MM-DD"); // 当前天数（当前系统的时间）
        // this.timeData[0] = tiem; // 默认今天时间    // 时间参数清空
        // this.timeData[1] = tiem; // 默认今天时间
        this.quickTime(null, 1);
        // this.timeData = []; // 时间参数清空
        this.formLabelAlign.examBeginDate = "";
        this.formLabelAlign.examEndDate = "";
        this.moduleValue = "-1";

        // this.thePielist();
        // this.init();
      });
    },
    // 获取列表数据
    async thePielist(type) {
      if (this.timeData) {
        const time = JSON.parse(JSON.stringify(this.timeData));
        this.formLabelAlign.examBeginDate = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.examEndDate = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let parmes = {
        parentId: this.moduleValue,
        beginTime: this.timeData[0] + " 00:00:00", // 开始时间
        // beginTime: "2023-06-17",
        // endTime: "2023-08-17",
        endTime: this.timeData[1] + " 23:59:59", // 结束时间
      };
      const { data } = await yklFirst.yklFirstEvente(parmes);
      if (data.Status == 200) {
        this.cardList[0].value = data.Data.registerNum;
        this.cardList[1].value = data.Data.loginNum;
        this.cardList[2].value = data.Data.homeIcon;
        this.cardList[3].value = data.Data.hospitalNum;
        this.tableData = data.Data.tableList;
        this.moduleArr = data.Data.moduleList;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.Data);
      }
    },
    // 快捷时间查询
    async quickTime(text, index) {
      this.isactive = index;
      let newaarr = [];
      let tiem = this.$moment().format("YYYY-MM-DD"); // 当前天数（当前系统的时间）
      if (text == 1) {
        let a = this.$moment(tiem).subtract(1, "days").format("YYYY-MM-DD"); // 昨天
        newaarr[0] = this.$moment(a).format("YYYY-MM-DD");
        newaarr[1] = tiem;
        this.timeData = newaarr;
      } else if (text == null) {
        newaarr[0] = tiem;
        newaarr[1] = tiem;
        this.timeData = newaarr;
      } else if (text == 7) {
        let a = this.$moment(tiem).subtract(7, "days").format("YYYY-MM-DD"); // 近七天
        newaarr[0] = this.$moment(a).format("YYYY-MM-DD");
        newaarr[1] = tiem;
        this.timeData = newaarr;
      } else if (text == 30) {
        let a = this.$moment(tiem).subtract(30, "days").format("YYYY-MM-DD"); // 近三十天
        newaarr[0] = this.$moment(a).format("YYYY-MM-DD");
        newaarr[1] = tiem;
        this.timeData = newaarr;
      }
      const topLine = Date.parse(this.timeData[0]); // 当前起始时间
      const date = new Date("2023-04-12");
      if (index !== 4 && topLine < date) {
        this.$alert(
          "系统上线时间为2023年08月12日，请以上线时间选起",
          "温馨提示",
          {
            confirmButtonText: "确定",
            callback: (action) => {},
          }
        );
      } else {
        // this.loading = true;
        // 自定义选择
        if (text === "null" && 4 === this.isactive) {
          this.whetherBtn = false;
        } else {
          this.whetherBtn = true;
        }
        //  this.thePielist();
        this.init();
      }
    },
    init() {
      if (this.tableType == 0) {
        this.loading = true;
        this.thePielist();
      } else if (this.tableType == 1 && this.$refs.tow) {
        this.$refs.tow.loading = true;
        this.$refs.tow.getTwoTable();
      } else if (this.tableType == 2 && this.$refs.three) {
        this.$refs.three.loading = true;
        this.$refs.three.getThreeTable();
      }
    },
    // 跳转二级表格
    toTwoTable(item) {
      // this.resetBtn(); // 重置一下
      this.rowObj = item;
      this.tableType = 1;
      // this.$refs.tow.getTwoTable()
    },
    // 返回
    toSte() {
      if (this.tableType == 1) {
        this.tableType = 0;
      } else if (this.tableType == 2) {
        this.tableType = 1;
      }
      this.init();
    },
    // 获取当前点击的二级ID
    getPointId(row) {
      this.$nextTick(() => {
        this.module = row.module;
        this.clsVnName = row.clsVnName;
        // this.resetBtn(); // 重置一下
        this.pointId = row.pointId;
        this.tableType = 2;
        // if(this.$refs.three){
        // this.$refs.three.getThreeTable()
        // }
      });
    },
  },
  created() {
    let tiem = this.$moment().format("YYYY-MM-DD"); // 当前天数（当前系统的时间）
    this.timeData[0] = tiem; // 默认今天时间    // 时间参数清空
    this.timeData[1] = tiem; // 默认今天时间
    // console.log(Date.parse("2023-08-14"));
    this.token.userID = this.$route.query.userID;
    this.token.guid = this.$route.query.guid;
    sessionStorage.setItem("old_yyptToken", JSON.stringify(this.token));
    this.thePielist();
    // console.log(this.$route.query, "获取参数", Date.now(), this.token);
  },
};
</script>

<style lang="scss" scoped>
.card_view {
  display: flex;
  padding: 24px;
  border-bottom: 1px solid #f1f1f1;
  li {
    // width: 300px;
    color: #fff;
    flex: 1;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
    &:nth-child(1) {
      background: #5292f9;
    }
    &:nth-child(2) {
      background: #9e74fa;
    }
    &:nth-child(3) {
      background: #f5be56;
    }
    &:nth-child(4) {
      background: #fa757c;
    }
    p {
      &:nth-child(2) {
        margin-top: 24px;
        font-size: 38px;
      }
    }
  }
}
.tiem_view {
  height: 90px;
  // border: 1px solid #000;
  display: flex;
  align-items: center;
  padding: 0px 24px;
  p {
    margin-right: 20px;
  }
  .el-button {
    width: 80px;
    height: 40px;
    margin-left: 0px !important;
    margin-right: 20px;
    // &:focus {
    //   background: #1890ff;
    //   color: #f8f8f8;
    // }
  }

  ::v-deep .el-range-editor.el-input__inner {
    margin-left: 104px;
    width: 380px;
  }
}
.sonbtn {
  .el-button {
    border: 1px solid #d9d9d9 !important;
    color: #999999;
    margin-left: 24px !important;
    width: 92px;
  }
}
.actived {
  background: #1890ff !important;
  color: #ffff;
}
.chang_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
.log_view {
  padding: 16px;
  h3 {
    letter-spacing: 6px;
  }
  p {
    color: #bbbbbb;
    font-size: 12px;
  }
  .el-button {
    width: 100px;
    height: 40px;
  }
}
.table_view {
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 24px;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}

.bd {
  color: #1890ff;
  border-bottom: 1px solid #1890ff;
}
.top {
  cursor: pointer;
}
</style>